/* global rp$, document, window */
import './fancybox.scss';

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');
	const { makeDivSticky } = require('public/js/lib/sticky-div');
	const {
		cleanupProductImages3dModule,
		hideProductImages3dViewer,
		MEDIA_TYPE_3D_MODEL_VALUE,
		mountProductImages3dThumbs,
		showProductImages3dViewer,
	} = require('./utils/product-images-3d-viewer.js');
	const { registerYouTubeIframeApiReady } = require('../product_media/utils/media-types.js');
	require('fancybox')(rp$);

	/********************************************
	 * Load Javascript for the Banner Vpicker Module
	 * -----------------------------------------
	 * @section product_images_js
	 ********************************************/
	(function ProductImagesModule() {
		var $imageModules;
		var scrollDir = true;
		var scrollCount = 0;
		var imageCount;
		var $productImages;
		var mobileBreakPoint = 768; // iPad
		var visibleAllowance = 3; // Show 3 Thumbnail Images
		var thumbnailMargin = 10; // 10px Padding
		var mediaPlayer = null;
		var unregisterYouTubeIframeApiReady = null;

		function cancelYouTubeIframeApiReadyWait() {
			if (typeof unregisterYouTubeIframeApiReady === 'function') {
				unregisterYouTubeIframeApiReady();
				unregisterYouTubeIframeApiReady = null;
			}
		}

		function createLegacyYouTubePlayer(videoId, youtubeVideoId) {
			if (!(globalThis.YT && globalThis.YT.Player)) {
				return false;
			}

			const playerTargetElement = document.getElementById(videoId);
			if (playerTargetElement === null) {
				return false;
			}

			mediaPlayer = new globalThis.YT.Player(videoId, {
				height: '260',
				width: '350',
				videoId: youtubeVideoId,
				playerVars: {
					rel: 0,
					modestbranding: 1,
					iv_load_policy: 3,
				},
			});

			return true;
		}

		function loadFancyboxModal($module) {
			var $secondaryImages = $module.find('.product-secondary-image');
			var activeIdx = 0;
			var carouselImages = [];
			var carouselIndex = 0;

			rp$.each($secondaryImages, function(_imageEleIdx, imageEle) {
				var $image = rp$(imageEle);
				var type = $image.data('image-type');

				if (type === MEDIA_TYPE_3D_MODEL_VALUE) {
					return;
				}

				if ($image.hasClass('active')) {
					activeIdx = carouselIndex;
				}

				if (type === 'YOUTUBE') {
					carouselImages.push({
						type: 'iframe',
						href: 'https://www.youtube.com/embed/'+ $image.data('image-id'),
					});
				} else {
					carouselImages.push({
						type: 'image',
						href: $image.data('image-main-url'),
						title: $image.data('caption'),
					});
				}

				carouselIndex++;
			});
			if (carouselImages.length === 0) {
				var $mainImageLink = rp$('.product-main-image-link');
				var $mainImageEl = $mainImageLink.find('.product-main-image');
				carouselImages.push({
					href: $mainImageEl.attr('src'),
					title: $mainImageLink.data('fancybox-title'),
				});
			}

			rp$.fancybox(carouselImages, {
				index: activeIdx,
				parent: '#rp_webstore',
			});
		}

		function selectMedia($module, $image) {
			var $productImageWrap = $module.find('.product-main-image-link');
			var $productImage = $module.find('.product-main-image');
			var $productVideo = $module.find('.product-video');
			var $productImages = $module.find('.product-images');
			var $productImageCaption = $module.find('.product-main-image-caption');
			var moduleId = $module.data('module-id');

			var image = {
				id: $image.attr('data-image-id'),
				type: $image.attr('data-image-type'),
				main: $image.attr('data-image-main-url'),
				preview: $image.attr('data-image-preview-url'),
				caption: $image.attr('data-caption'),
				modelUrl: $image.attr('data-model-url'),
			};

			// Set Active Flag On secondary images
			$module.find('.product-secondary-image').removeClass('active');
			$image.addClass('active');

			if (image.type === MEDIA_TYPE_3D_MODEL_VALUE) {
				$productVideo.hide();
				cancelYouTubeIframeApiReadyWait();
				if (mediaPlayer && typeof mediaPlayer.destroy === 'function') {
					mediaPlayer.destroy();
					mediaPlayer = null;
				}
				showProductImages3dViewer($module, image.modelUrl || '', {
					catalog: $module.attr('data-catalog'),
					skuStripped: $module.attr('data-sku-stripped'),
				});
			} else {
				hideProductImages3dViewer($module);

				if (image.type === 'YOUTUBE') {
					var videoId = 'product_image_video'+ moduleId;
					var youtubeVideoId = image.id;
					$productImageWrap.hide();
					$productVideo.show();

					cancelYouTubeIframeApiReadyWait();
					if (mediaPlayer && typeof mediaPlayer.destroy === 'function') {
						mediaPlayer.destroy();
						mediaPlayer = null;
					}

					$productVideo.empty();
					$productVideo.append('<div id="'+ videoId +'"></div>');

					if (!createLegacyYouTubePlayer(videoId, youtubeVideoId)) {
						unregisterYouTubeIframeApiReady = registerYouTubeIframeApiReady(function onLegacyYouTubeIframeApiReady() {
							createLegacyYouTubePlayer(videoId, youtubeVideoId);
						});
					}
				} else {
					$productVideo.hide();
					cancelYouTubeIframeApiReadyWait();
					if (mediaPlayer && typeof mediaPlayer.destroy === 'function') {
						mediaPlayer.destroy();
						mediaPlayer = null;
					}
					$productImageWrap.show();
					$productImage.attr('src', image.main);
				}
			}

			if(image.caption) {
				$productImageCaption.html(image.caption);
				$productImages.addClass('show-caption');
			} else {
				$productImageCaption.html('');
				$productImages.removeClass('show-caption');
			}
		}

		function thumbnailScroll($module, vertCarouselButton, scrollMax) {
			var $scrollContainer = $module.find('.secondary-images');
			var imageHeight = $scrollContainer.find('.product-secondary-image').height();

			// Scroll up or down
			if(scrollCount >= 0 && scrollDir === true) {
				scrollCount++;
				$scrollContainer.css('top', "-="+(imageHeight+thumbnailMargin));
				if(scrollCount >= scrollMax) {
					scrollDir = false;
					vertCarouselButton.addClass('buttonDown').removeClass('buttonUp');
				}
			} else if(scrollDir === false) {
				scrollCount--;
				$scrollContainer.css('top', "+="+(imageHeight+thumbnailMargin));
				if(scrollCount === 0) {
					scrollDir = true;
					vertCarouselButton.addClass('buttonUp').removeClass('buttonDown');
				}
			}

			// Wait for animation to complete / Prevent Spam click
			vertCarouselButton.css('pointer-events', "none");
			setTimeout(function(){vertCarouselButton.css('pointer-events', "auto")}, 260);
		}

		function shouldUseThumbnailCarousel($imagesModule, localImageCount) {
			const hasColumnLayout = $imagesModule.hasClass('product-images-module-column-layout');
			const hasPdpRedesignGallery = $imagesModule.closest('.pdp-redesign-gallery-column').length > 0;

			return hasColumnLayout
				|| hasPdpRedesignGallery
				|| (rp$(window).width() < mobileBreakPoint && localImageCount > visibleAllowance);
		}

		function initThumbnailCarousel($imagesModule, localImageCount) {
			var $productImagesList = $imagesModule.find('.secondary-images');

			if (typeof rp$.fn.owlCarousel !== 'function') {
				return;
			}

			if (shouldUseThumbnailCarousel($imagesModule, localImageCount)) {
				if ($productImagesList.hasClass('owl-carousel')) {
					return;
				}

				$productImagesList.addClass('owl-carousel').owlCarousel({
					margin: 8,
					nav: true,
					navText: false,
					loop: false,
					responsive: {
						0: {
							items: 3
						},
						500: {
							items: 4
						}
					},
					itemElement: 'ul',
					onInitialized: function () {
						$productImagesList.find('.owl-stage-outer').contents().unwrap().wrap('<li/>');
						$productImagesList.find('.owl-dots').contents().unwrap().wrap('<li/>');
						$productImagesList.find('.owl-nav').contents().unwrap().wrap('<li/>');
					},
				});

				return;
			}

			if ($productImagesList.hasClass('owl-carousel')) {
				$productImagesList.trigger('destroy.owl.carousel').removeClass('owl-carousel');
			}
		}

		/********************************************
		.* Attach
		.* -----------------------------------------
		.* Attach events to each module instance
		.********************************************/
		function attachEvents() {
			$imageModules = rp$('.product-images-module');

			rp$.each($imageModules, function MobileCarousel_Iterator(idx, imagesModule) {
				var $imagesModule = rp$(imagesModule);
				$productImages = $imagesModule.find('.secondary-images');
				const hasColumnLayout = $imagesModule.hasClass('product-images-module-column-layout');
				const hasPdpRedesignGallery = $imagesModule.closest('.pdp-redesign-gallery-column').length > 0;
				// Static desktop selectors
				var $thumbButton = $imagesModule.find('.thumbnails-scroll-button');
				var $ulWrap = $imagesModule.find('.secondary-images-wrapper');
				var imageHeight = $imagesModule.find('.product-secondary-image').height();
				imageCount = $imagesModule.find('.product-secondary-image').length;
				var thumbsHeight = imageCount * imageHeight;

				// Set ScrollMax
				var scrollMax = 0;
				if (rp$(window).width() > mobileBreakPoint && !hasColumnLayout && !hasPdpRedesignGallery) {
					if(thumbsHeight <= $ulWrap.height()) {
						scrollMax = 0;
						$thumbButton.hide();
					} else {
						scrollMax = imageCount - visibleAllowance;
						$thumbButton.show();
					}
				}

				/* Carousel Variables
				.*-----------------------------------------*/
				initThumbnailCarousel($imagesModule, imageCount);
				mountProductImages3dThumbs($imagesModule);

				var $activeThumb = $imagesModule.find('.product-secondary-image.active');
				if ($activeThumb.length > 0 && $activeThumb.attr('data-image-type') === MEDIA_TYPE_3D_MODEL_VALUE) {
					selectMedia($imagesModule, $activeThumb);
				} else {
					var initialModelUrl = $imagesModule.attr('data-initial-3d-model-url');
					if (initialModelUrl) {
						showProductImages3dViewer($imagesModule, initialModelUrl, {
							catalog: $imagesModule.attr('data-catalog'),
							skuStripped: $imagesModule.attr('data-sku-stripped'),
							skipTracking: true,
						});
					}
				}

				/* Handle Image click
				.*-----------------------------------------*/
				$productImages.on('click', '.product-secondary-image', function SelectProductImage(e) {
					e.preventDefault();
					selectMedia($imagesModule, rp$(this));
				});

				$imagesModule.on('click', '.enlarge-image-overlay', function clickToEnlarge(e) {
					e.preventDefault();
					loadFancyboxModal($imagesModule);
				});

				// Thumbnail Button click
				$thumbButton.on('click', function(e) {
					e.preventDefault();
					thumbnailScroll($imagesModule, rp$(this), scrollMax);
				});

			});

			makeDivSticky('.product-images-module');
		}

		rp$(document).on('setProductImages:html', function HandleNewProductImagesHtml(evt, html) {
			rp$('.product-images-module').each(function(_idx, moduleEl) {
				cleanupProductImages3dModule(rp$(moduleEl));
			});
			rp$('.product-images-module').html(html);
			attachEvents();
		});

		// Reset on resize.
		rp$(window).on('resize', function(){
			rp$('.secondary-images').css('top', "0"); // Reset vertical scroll
			rp$('.thumbnails-scroll-button').addClass('buttonUp').removeClass('buttonDown');
			scrollDir = true;
			scrollCount = 0;

			rp$.each(rp$('.product-images-module'), function resizeCarouselIterator(idx, imagesModule) {
				var $imagesModule = rp$(imagesModule);
				var localImageCount = $imagesModule.find('.product-secondary-image').length;
				initThumbnailCarousel($imagesModule, localImageCount);
			});
		});

		$onReady({
			rp$, window,
			label: 'product_images',
			fn: attachEvents,
		});

	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
